import { useMutation } from "@tanstack/react-query";
import { useAxiosWithoutToken } from "../../../api/axios";
import { useTranslation } from "react-i18next";
import { LoginWithSF } from "../../../utils/inv-exch-amplitude";

interface LoginData {
  access_token: string | null;
  refresh_token: string | null;
  instance_url: string | null;
  id: string | null;
  issued_at: number | null;
  signature: string | null;
  scope: string | null;
  token_type: string | null;
}

export const useUserLoginWithSF = (
  onSuccess?: void | ((data: any) => void),
  onError?: void | ((error: any) => void)
) => {
  const axios = useAxiosWithoutToken();
  const { t } = useTranslation();
  const urlKey = t("login-end-point");
  // const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: LoginData) => {
      const response = await axios.post(urlKey, data);
      return response.data;
    },
    onSuccess: (data) => {
      // queryClient.setQueryData(['loginUser'], data.data);
      localStorage.setItem("user-detail", JSON.stringify(data.data));
      LoginWithSF({
        user_id: data.data?.sfid,
        login_method: "login with salesforce",
      });
      // const userData = queryClient.getQueryData(['loginUser']);
      if (onSuccess) {
        onSuccess(data);
      }
    },
    onError: (err) => {
      console.error("error", err);
      if (onError) {
        onError(err);
      }
    }
  });
};
